import { useEffect, useState } from 'react';
import { Cradle } from '@solo/app-core';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { translate } from '@/app/i18n';
import { Flex, Text, Icon, RouterLink } from '@/app/ui';
import Colors from '@/app/styles/Colors';
import { useCradle } from '@/app/contexts';
import { useBlocState } from '@/app/hooks';

const VerifyEmailPage = () => {
  const { authBloc, userBloc } = useCradle<Cradle>();
  const authState = useBlocState(authBloc);
  const { token } = useParams();
  const navigate = useNavigate();

  const [isVerified, setIsVerified] = useState<boolean>(false);

  const verifyEmail = async () => {
    if (!token) {
      toast.error(translate('VERIFY_EMAIL.ERROR_VERIFY_EMAIL'));
      return;
    }
    try {
      await userBloc.validateEmailConfirm({ token });
      setIsVerified(true);
    } catch (error) {
      toast.error(translate('VERIFY_EMAIL.ERROR_VERIFY_EMAIL'));
      navigate('/');
    }
  };
  useEffect(() => {
    if (authState.kind !== 'AuthenticatedAuthState') {
      navigate('/');
      return;
    }
    if (token) {
      verifyEmail();
    }
  }, [authState]);

  return (
    <Flex.Container
      flexDirection="column"
      alignItems="center"
      style={{ backgroundColor: Colors.white, marginTop: '15%' }}
    >
      {isVerified && (
        <Flex.Container flexDirection="column" alignItems="center">
          <Icon.SpinnerCheckIcon width={120} />
          <Text.Title2>{translate('VERIFY_EMAIL.EMAIL_VERIFIED')}</Text.Title2>
          <Text.Paragraph>{translate('VERIFY_EMAIL.EMAIL_VERIFIED_DESCRIPTION')}</Text.Paragraph>
          <RouterLink $transparent to="/dashboard">
            <Text.SectionSubtitleBold style={{ color: Colors.primary }}>
              {translate('VERIFY_EMAIL.GO_TO_DASHBOARD')}
            </Text.SectionSubtitleBold>
          </RouterLink>
        </Flex.Container>
      )}
    </Flex.Container>
  );
};
export default VerifyEmailPage;
